import React, { FunctionComponent, useEffect } from "react";
import "./VideoLessonsTopic.scss";
import VideoCard from "../../../Components/VideoCard/VideoCard";
import { useNavigate, useLocation } from "react-router-dom";
import { listVideoTopic } from "../../../Redux/Slices/UserVideoLessons/ListVideoTopicSlice";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import { VideoLessonTopicParams } from "./IVideoLessonDashboard";

const VideoLessonsTopic: FunctionComponent = () => {
  const isUCAT =
    window.location.hostname.split(".")[0]?.includes("ucat") ||
    window.location.hostname.split(".")[0] === "192";
  const navigate = useNavigate();
  const location = useLocation();
  const { subjectId, Subject_name } = location.state || {};

  const dispatch = useAppDispatch();
  useEffect(() => {
    let id = subjectId;

    // If subjectId is not available in location.state, try sessionStorage
    if (!id) {
      id = sessionStorage.getItem("subjectId") || "";
    } else {
      sessionStorage.setItem("subjectId", id);
    }

    if (id) {
      dispatch(listVideoTopic({ subject_id: id }));
    } else {
      console.error("subjectId not found");
    }
  }, [dispatch, subjectId]);

  useEffect(() => {
    dispatch(listVideoTopic({ subject_id: subjectId }));
  }, [dispatch]);

  const { data: topicFromAPI } = useAppSelector(
    (state) => state.ListVideoTopicSliceReducer
  );

  const handleCardClick = (
    topic: VideoLessonTopicParams
  ) => {
    if (!topic.has_access) {
      return;
    }

    navigate("/videolessondetails", {
      state: {
        subjectId,
        topicId: topic.id,
        topicName: topic.name,
      },
    });
  };


  function formatTime(totalSeconds: number | string) {
    if (totalSeconds == null) return "00h 00m 00s";

    let seconds = 0;

    if (typeof totalSeconds === "string" && totalSeconds.includes(":")) {
      // case: input is "hh:mm:ss"
      const parts = totalSeconds.split(":").map((v) => parseInt(v, 10));
      if (parts.length === 3) {
        seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
      } else if (parts.length === 2) {
        seconds = parts[0] * 60 + parts[1];
      }
    } else {
      seconds = Number(totalSeconds);
    }

    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    return `${String(h).padStart(2, "0")}h ${String(m).padStart(2, "0")}m`;
  }

  return (
    <div className="video-lessons-dashboard">
      <div className="header-bar">
        <button
          className="back-button"
          onClick={() => navigate("/videolessons")}
        >
          ←
        </button>
        <div className="dashboard-header">
          <h1>{Subject_name}</h1>
          <p>Comprehensive video tutorials for each section of the {isUCAT ? "UCAT" : "GATE"} exam</p>
        </div>
      </div>

      <div className="video-cards-grid">
        {topicFromAPI?.data?.map((topic, index) => (
          <VideoCard
            key={topic.id || index}
            imageSrc={
              topic.image || "https://via.placeholder.com/400x225?text=No+Image"
            }
            duration={formatTime(String(topic.total_duration))}
            title={topic.name}
            description={topic.description || "No description available"}
            videoCount={topic.video_count || 0}
            completion={topic.percent_completed || 0}
            buttonText={
              !topic.has_access
                ? "Upgrade Now"
                : topic.percent_completed > 0
                  ? "Continue Learning"
                  : "Start Learning"
            }
            tooltipText={!topic.has_access ? "Subscribe to access videos" : ""}
            onCardClick={() => handleCardClick(topic)}
          />
        ))}
      </div>
    </div>
  );
};

export default VideoLessonsTopic;
